
import {
    GET_ALL_REPORTS_SUCCESS,
    GET_ALL_REPORTS_FAILED
} from "../actions/types";

const initialState = {
    isAuthorized: null,
    version: null,
    roleID: null,
    userID: null,
    userCF: null,
    userCS: null,
    userCT: null,
    statusMsg: null,
}

const usersReducers = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_REPORTS_SUCCESS:
            return {
                ...state,
                isAuthorized: action.response.isAuthorized,
                version: action.response.version,
                roleID: action.response.roleID,
                userID: action.response.userID,
                userCF: action.response.userCF,
                userCS: action.response.userCS,
                userCT: action.response.userCT,
                statusMsg: action.response.statusMsg,
            };

        case GET_ALL_REPORTS_FAILED:
            return {
                ...state,
                errorMessage: action.message,
            };
        default:
            return state;
    }
}

export default usersReducers;
